import DeferredPaymentMessage from './deferred-payment-message'

export default DeferredPaymentMessage
